<template>
	<div class="p-fluid">
		<div>
			<p>
				<!--<b>{{ question }}</b>-->
				<b v-if="questionMark">
					<QuestionComments :questionMark="questionMark" :question="question" />
				</b>
				<b v-else> {{ question }} </b>
			</p>
			<HelpTooltip v-if="bookmark != undefined" :helpbookmark="bookmark" />
		</div>

		<!-- Listen to on change event instead of v-on:input to achieve same result as v-model.lazy -->
		<!-- <input
        v-bind:value="value"
        v-on:change="$emit('input', $event.target.value)"
      > -->
		<div class="p-inputgroup">
			<InputText
				type="text"
				:value="value && typeof value === 'object' && Object.keys(value).length === 1 && 'nullValue' in value ? '' : value"
				:placeholder="placeholder"
				@change="$emit('input', $event.target.value)"
			/>
			<Button
				v-if="(value === '' || (typeof value === 'object' && Object.keys(value).length === 1 && 'nullValue' in value)) && placeholder"
				label="Keep Example"
				@click="fillWithPlaceholder()"
			/>
			<Button
				v-if="(value != '' && typeof value != 'object' )"
				label="Clear"
				class="p-button-danger"
				@click="clearInput()"
			/>
		</div>
	</div>
</template>

<script>
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import HelpTooltip from "../components/HelpTooltip";
import QuestionComments from "./QuestionComments.vue";

export default {
	name: "InputTextSingleLine",
	props: {
		question: String,
		value: String,
		placeholder: String,
		bookmark: String,
		questionMark: String
	},
	components: {
		InputText,
		Button,
		HelpTooltip,
		QuestionComments
	},
	methods: {
		fillWithPlaceholder() {
			this.$emit("input", this.placeholder);
		},
		clearInput() {
			this.$emit("input", "");
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
